import css from 'styled-jsx/css';

const styles = css.global`html.scroll-disabled {
  overflow: hidden !important;
}

#modal-seguros {
  width: 100%;
  height: 100vh;
  background-color: rgba(34, 34, 34, 0.6);
  position: fixed;
  z-index: 9999999;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  overflow-y: scroll;
}

#modal-seguros .modal {
  position: relative;
  background: #fff;
  padding: 16px 16px 40px 16px;
  border-radius: 4px;
  border: 1px solid #CCC;
  box-shadow: 0px 2px 16px -2px rgba(34, 34, 34, 0.40);
  width: 100%;
  max-width: 800px;
  height: calc(100vh - 20px);
  max-height: 691px;
  min-height: 590px;
  z-index: 10000;
}

#modal-seguros .modal .close-modal {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
}

#modal-seguros .modal .modal-seguros-titulo {
  color: #222;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}


#modal-seguros .modal-seguros-docs {
  max-height: 500px;
  height: calc(100vh - 78px);
  overflow-y: scroll;
  padding-right: 40px;
  margin-top: 20px;
}

#modal-seguros .modal-seguros-doc {
  padding: 16px 0 17px;
  border-bottom: 1px solid #CCCCCC;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#modal-seguros .modal-seguros-doc-infos {
  display: flex;
  align-items: center;
  gap: 8px;
}

#modal-seguros .modal-seguros-doc-titulo {
  color: #222;
  font-family: "SantanderText";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; 
}

#modal-seguros .modal-seguros-doc-descricao {
  color: #444;
  font-family: "SantanderMicroText";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 22px;
}

#modal-seguros .modal-seguros-doc-baixar {
  color: #C00;
  text-align: right;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
}

#modal-seguros .btn-baixar-todos a {
  width: 100%;
  max-width: 216px;
  height: 48px;
  margin: 20px auto 0;
}

@media (min-width: 992px) {
  #modal-seguros .modal {
    padding: 16px 44px 40px 16px;
  }

  #modal-seguros .modal-seguros-doc-titulo {
    font-size: 18px;
    line-height: 28px; 
  }
  
  #modal-seguros .btn-baixar-todos {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }

  #modal-seguros .btn-baixar-todos a {
    margin: 40px 58px 0 0;
  }
}`;

export default styles;